import {notify} from "@kyvg/vue3-notification";
import axios from "axios";

export default {
    namespaced: true,

    state: () => ({
        users: [],
        user: null,
        userId: null,
        userToken: null,
        totalUsers: null,
        userTrajectories: null
    }),

    mutations: {
        setUser(state, data) {
            state.user = data;
        },
        setUsers(state, data) {
            state.users = data;
        },
        setUsersWhiteList(state, data) {
            state.usersWhiteList = data
        },
        setUserId(state, data) {
            state.userId = data;
        },
        setUserToken(state, data) {
            state.userToken = data;
        },
        setTotalUsers(state, data) {
            state.totalUsers = data;
        },
        setUserTrajectories(state, data) {
            state.userTrajectories = data;
        },
    },

    actions: {
        // eslint-disable-next-line no-unused-vars
        async createUser({commit}, data) {
            await axios.post(`/users`, data)
                .then(({data}) => {
                    commit("setUserId", data.id)
                    notify({
                        title: "Данные сохранены",
                        type: "success"
                    })
                });
        },
        async getUser({commit}, id) {
            await axios.get(`/users/${id}`)
                .then(({data}) => {
                    commit("setUser", data)
                })
        },
        async getUsers({commit}, data) {
            await axios.get(`/users?per_page=${data.perPage}&page=${data.page}&${data.sort ? data.sort : ''}`)
                .then(({data}) => {
                    commit("setUsers", data.users)
                    commit("setTotalUsers", data.meta.total)
                })
        },
        async getUsersWhiteList({commit}) {
            await axios.get(`/users/whiteList`)
                .then(({data}) => {
                    commit("setUsersWhiteList", data)
                })
        },
        async getUsersWhiteListBySearch({commit}, data) {
            await axios.get(`/users/whiteList?date=${data}`)
                .then(({data}) => {
                    commit("setUsersWhiteList", data)
                })
        },
        async getUsersBySearch({commit}, data) {
            await axios.get(`/users/staffSearch?per_page=${data.perPage}&page=${data.page}&name=${data.name}&email=${data.email}&role=${data.role}`)
                .then(({data}) => {
                    commit("setUsers", data.users)
                    commit("setTotalUsers", data.meta.total)
                })
        },
        async updateUser({commit}, data) {
            await axios.put(`/users/${data.id}`, data.form)
                .then(({data}) => {
                    commit("setUser", data)
                    notify({
                        title: "Данные сохранены",
                        type: "success"
                    })
                })
        },
        async getUserToken({commit}, id) {
            await axios.get(`/users/${id}/token`)
                .then(({data}) => {
                    commit("setUserToken", data)
                })
        },
        async getUserTrajectories({commit}, id) {
            await axios.get(`/users/${id}/trajectories`)
                .then(({data}) => {
                    commit("setUserTrajectories", data)
                })
        }
    }
}